function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn } from "../../common/helpers.js";
/**
 * Header - [API](https://scl.sharp.com/?path=/docs/components-header) | [DSM](https://sharphealthcare.notion.site/Header-d4d0d33eb171402ab8dc5ad5cf47499a)
 */ const Header = /*#__PURE__*/ forwardRef((_param, ref)=>{
    var { menu, link = '/', logo, center, right, className } = _param, props = _object_without_properties(_param, [
        "menu",
        "link",
        "logo",
        "center",
        "right",
        "className"
    ]);
    return /*#__PURE__*/ _jsx("header", _object_spread_props(_object_spread({}, props), {
        ref: ref,
        className: cn('sticky top-0 transition-colors z-20 bg-white drop-shadow-header', className),
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container flex gap-4 md:justify-between items-center h-16",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center gap-x-8 flex-1 md:flex-initial",
                    children: [
                        menu,
                        /*#__PURE__*/ _jsx("a", {
                            href: link,
                            className: "hidden md:block",
                            children: logo
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "hidden lg:block ml-4",
                            children: center
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "flex justify-center md:hidden",
                    children: /*#__PURE__*/ _jsx("a", {
                        href: link,
                        children: logo
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "flex justify-end flex-1 md:flex-initial",
                    children: right
                })
            ]
        })
    }));
});
export { Header };
